import { useCallback, useMemo } from 'react'
import { ReasonField } from './ReasonField'
import { form } from './formState'

export function ReasonFields() {
  const { formApi } = form.useFormField('reasonsForNotCompletedOrders')

  const errors = formApi.getErrors()?.reasonsError

  const renderItem = useCallback(
    ({ value, onChange }) => <ReasonField value={value} onChange={onChange} />,
    [],
  )

  const dynamicListProps = useMemo(
    () => ({
      RenderItem: renderItem,
      sorting: 'on' as const,
      components: {
        ActionBarContainer: () => undefined,
      },
    }),
    [renderItem],
  )

  return (
    <form.DynamicList
      name="reasonsForNotCompletedOrders"
      validateOn="change"
      defaultValue=""
      dynamicListProps={dynamicListProps}
      helperText={errors?.message || null}
      data-testid="reason-for-orders_reason-txt"
      data-trackid="reason-for-orders_reason-txt"
    />
  )
}
